import { Link } from "react-router-dom";
import { PageHero } from "../components/PageShell";
import { CENTERS, INSTITUTE_RESEARCH } from "../lib/researchCenters";
import { ROUTES } from "../lib/routes";

const R = INSTITUTE_RESEARCH;

/** Counts are null where the centre returned "Nil" — show a dash, never a 0. */
const num = (n: number | null) => (n == null ? "—" : String(n));

export default function Research() {
  return (
    <>
      <PageHero
        variant="hero-editorial hero-compact"
        fullWidthTitle
        eyebrow="Research"
        title="Research with purpose."
        lead={R.headline}
        crumbs={[{ label: "Research" }]}
        image={null}
      />
      {/* No stat grid here, and no figures in the hero's lead (R.headline):
          scholar, grant and publication counts change too often to state. */}
      <section className="section section-tight">
        <div className="container">
          <div className="section-head">
            <div>
              <div className="kicker">Centres of excellence</div>
              <h2>Where research happens</h2>
            </div>
            <p className="meta">
              {CENTERS.length} of {R.centres} centres have published a profile.
            </p>
          </div>
          <div className="research-grid">
            {CENTERS.map((c) => (
              <div key={c.slug} className="research-card reveal">
                <div className="kicker">Research Centre</div>
                <h3>{c.name}</h3>
                <p style={{ color: "var(--text-soft)" }}>{c.desc}</p>
                <div className="stats">
                  <div><b>{num(c.scholars)}</b>Scholars</div>
                  <div><b>{num(c.projects)}</b>Funded projects</div>
                  <div><b>{num(c.pubs)}</b>Publications · 5y</div>
                </div>
                <Link
                  className="btn-link"
                  to={`${ROUTES.researchCenter}/${c.slug}`}
                  style={{ alignSelf: "flex-end" }}
                >
                  Visit centre <span className="arr">→</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="section section-deep">
        <div className="container">
          <div className="section-head" style={{ borderColor: "rgba(255,255,255,0.15)" }}>
            <div>
              <div className="kicker">Funders & sponsored research</div>
              <h2 style={{ color: "#fff" }}>Agencies we work with</h2>
            </div>
          </div>
          <div className="recruiters-grid">
            {R.funders.map((p) => (
              <div key={p} className="recruiter-tile" style={{ background: "rgba(255,255,255,0.04)", color: "#fff" }}>{p}</div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
